import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

interface ApiResponse {
    statusCode: number;
    [key: string]: unknown;
}

function handle401(): void {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
}

export const AuthErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const toastService = inject(ToastService);

    const handle403 = () => {
        toastService.warn({ detail: 'cropmap.common.forbidden' });
    };

    const checkStatus = (statusCode: number) => {
        if (statusCode === 401) handle401();
        else if (statusCode === 403) handle403();
    };

    return next(req).pipe(
        tap((event) => {
            if (!(event instanceof HttpResponse)) return;

            if (event.body && typeof event.body === 'object' && !(event.body instanceof Blob)) {
                const body = event.body as Record<string, unknown>;
                if ('statusCode' in body) {
                    checkStatus((body as unknown as ApiResponse).statusCode);
                }
                return;
            }

            if (event.body instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const parsed = JSON.parse(reader.result as string) as Partial<ApiResponse>;
                        if (parsed?.statusCode) checkStatus(parsed.statusCode);
                    } catch { /* not JSON */ }
                };
                reader.readAsText(event.body);
            }
        }),
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                checkStatus(error.status);
            }
            return throwError(() => error);
        }),
    );
};
